import React, { useState } from 'react';

import { GridList, GridListTile, makeStyles, Input } from '@material-ui/core';

import ComponentToolbar from './ComponentToolbar'
import ModalEditStats from './ModalEditStats'

import SkillCard from './SkillCard'

import Grid from '@material-ui/core/Grid';


import skillsInfos from '../utils/SkillsInfo'

const useToolbarStyles = makeStyles((theme) => ({
  gridSkillsList: {
    height: 600,
    display: 'flex',
    justifyContent: 'center',
  },
}));

const Skills = ({ skills, setSkills }) => {
  const classes = useToolbarStyles();
  const [filter, setFilter] = useState("");

  return (
    <React.Fragment>
      <ComponentToolbar
        title={"Pericias"}
      >
        <Grid item>
          <Input value={filter} onChange={(e) => setFilter(e.target.value.toLowerCase())} style={{ width: '100px' }} />
        </Grid>
        <Grid item>
          <ModalEditStats valueState={skills} setState={setSkills} onlyNumeric={true} />
        </Grid>
      </ComponentToolbar>

      <GridList
        className={classes.gridSkillsList}
        cols={4}
        spacing={4}
        cellHeight={156}
      >
        {skillsInfos.skillsNames.filter(skill => skill.toLowerCase().includes(filter)).map((skill, index) =>
        (
          <GridListTile
            key={index}
            cols={1}
          >
            <SkillCard skillName={skill} skillValue={skills[skill]} />
          </GridListTile>
        ))
        }
      </GridList>

    </React.Fragment>
  );
}

export default Skills;









